//@ts-check
//import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";
import { SaveButton } from "./components/SaveButton";
import { HasAttachments } from "./CRUDs/abstracts/mixins/HasAttachments";
import { CRUDFabric } from "./CRUDs/CRUDFabric";

export default class PriceBook{

    static async init(){
        if(!/^\/price-book/.test(location.pathname))
            return
        $('#price-book-tables .bb-preloader-container').removeClass('d-none');
        let entity = $('.data-view')?.attr('data-entity');
        $('#create-btn').off('click').on('click', this.getFormForEvent.bind(this))
        if(entity){
            $('body').off('click', '.stafter-table-body tr td+td').on('click', '.stafter-table-body tr td+td', this.getFormForEvent.bind(this))
            $('.stafter-table-body tr td').removeAttr('onclick')
        }
    }

    static getFormForEvent(ev){
        let elem = $(ev.currentTarget)
        if(elem.prop('tagName').toLowerCase() == 'td')
            elem = $(elem.parents('tr')[0])
        const entity = elem.attr('data-entity')
        const type = elem.attr('data-type')
        let addData={}
        addData[`${entity}_id`] = elem.attr('data-id')
        this.getForm(this.createOrUpdate, entity, type, addData)
    }

    static getForm(callback, entity, type, addParam={}){
        return new Promise(resolve=>{
            $.ajax({
                type: 'GET',
                url: '/price-book/form',
                data: {entity, type, ...addParam},
                success: (response) => {
                    $('#form-container').html(response);
                    $(`#invoice-${entity}-modal`).modal('show');
                    $(`#invoice-${entity}-modal #${type}`).on('click', callback.bind(this))
                    if(entity =='item'){
                        $(`#invoice-${entity}-modal`).on('input', 'input[name="price"], input[name="unit_cost"]',this.maskNumber)
                        $(`#invoice-${entity}-modal`).on('input', 'input[name="quantity"]',this.maskInteger)
                        this.setupItemFormHandlers();
                        // Update upload button state and show existing image after modal content is loaded
                        setTimeout(() => {
                            PriceBook.updateUploadButtonState();
                            PriceBook.loadExistingImage();
                        }, 100);
                    }
                    resolve(true)
                },
                error:()=>resolve(false)
            });
        })
    }

    static validateItem(data){
        let messages=[]
        if(!data?.name || !data?.name?.length)
            messages.push('The "name" field is not filled in correctly.')
        if(!data?.price || isNaN(Number(data?.price)))
            messages.push('The "price" field is not filled in correctly.')
        if(!data?.price || isNaN(Number(data?.price)))
            messages.push('The "price" field is not filled in correctly.')
        if(!data?.quantity || isNaN(Number(data?.quantity)))
            messages.push('The "quantity" field is not filled in correctly.')
        return messages.length ? {success:false, errors:messages} : {success:true}
    }

    static getDataForInvoice(ev){
        const entity = $(ev.currentTarget).attr('data-entity');
        const formId = `#invoice-${entity}-form`
        let SaveBtn = new SaveButton(formId, '#' + ev.currentTarget.id);
        SaveBtn.startLoading()
        try{
            let data = this.getFormData(formId)
            data.service_type = $(`${formId} select[name=type] option[value="${data.type}"]`).text()
            let result = this.validateItem(data)
            if(!result?.success){
                SaveBtn.stopLoading().then(() => {
                    SaveBtn.showError(result.errors?.join(' '))
                });
                return false
            }else{
                SaveBtn.stopLoading(true).then(() => {
                    SaveBtn.showSuccess().then(() => {
                        $(`#invoice-${entity}-modal`).modal('hide');
                    });
                });
                return data
            }
        }catch(err){
            SaveBtn.stopLoading().then(() => {
                SaveBtn.showError(err.message)
            });
            return false
        }
        
    }

    static createOrUpdate(ev){
        return new Promise((resolve, reject)=>{
            const entity = $(ev.currentTarget).attr('data-entity');
            const formId = `#invoice-${entity}-form`
            let data = this.getFormData(formId)
            let category_id = $(ev.currentTarget).attr('data-id');
            if (category_id)
                data.category_id = category_id
            let SaveBtn = new SaveButton(formId, '#' + ev.currentTarget.id);
            $.ajax({
                type: 'POST',
                url: `/price-book/${entity}/${ev.currentTarget.id}`,
                data: data,
                beforeSend: () => {
                    SaveBtn.startLoading()
                },
                success: (response) => {
                    if (response?.success) {
                        const imagePath = $(`#invoice-${entity}-modal`).data('image-path') || $(`#invoice-${entity}-modal #item-image-path`).val();
                        const imageUrl = imagePath ? `/files/${imagePath}` : '';
                        
                        // Update image in table if item is being edited in quote form
                        if (response?.id && imagePath) {
                            PriceBook.updateImageInTable(response.id, imageUrl);
                        }
                        
                        // So addAnotherLine can show image when adding new item to quote/invoice table
                        data.image_url = imageUrl || data.image_url || '';
                        
                        // Clear stored image_path after successful save
                        $(`#invoice-${entity}-modal`).removeData('image-path');
                        $(`#invoice-${entity}-modal #item-image-path`).val('');
                        
                        SaveBtn.stopLoading(true).then(() => {
                            SaveBtn.showSuccess().then(() => {
                                $(`#invoice-${entity}-modal`).modal('hide');
                            });
                            if(typeof fetchTableData == 'function')
                                fetchTableData()
                        });
                        data.id = response?.id
                        data.service_type = response?.service_type
                        resolve(data)
                    } else {
                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showError(response?.error)
                        });
                        resolve(false)
                    }
                },
                error: () => {
                    SaveBtn.stopLoading().then(() => {
                        SaveBtn.showError();
                    });
                    resolve(false)
                }
            })
        })
    }

    static getFormData(formId){
        let data = {};
        let inputs = $(`${formId} input:not([type=checkbox]), ${formId} textarea, ${formId} select`);
        for (let input of inputs) 
            data[$(input).attr('name')] = $(input).val();
        inputs = $(`${formId} input[type=checkbox]`);
        for (let input of inputs) 
            data[$(input).attr('name')] = $(input).is(':checked') ? 1 : 0;
        
        // Add image_path if it was uploaded (from modal data or hidden input)
        const imagePath = $(`${formId}`).closest('#invoice-item-modal').data('image-path') || $(`${formId} #item-image-path`).val();
        if (imagePath) {
            data.image_path = imagePath;
        }
        
        return data
    }

    static attachPreparedFiles(itemId){
        if(!(HasAttachments.prepareFiles instanceof FormData) || !itemId){
            return Promise.resolve(true)
        }
        HasAttachments.id = itemId
        HasAttachments.urlRoot = '/price-book/item'
        HasAttachments.isPrepareFiles = false
        return new Promise(resolve=>{
            $.ajax({
                url: HasAttachments.attachmentUrl(),
                method: 'POST',
                processData: false,
                contentType: false,
                data: HasAttachments.prepareFiles,
                success: (response) => {
                    HasAttachments.prepareFiles = null;
                    this.handleAttachmentsUploaded(response);
                    resolve(true);
                },
                error: () => resolve(false)
            })
        })
    }

    static setupItemFormHandlers(){
        // Update upload button state when modal is shown
        $('#invoice-item-modal').on('shown.bs.modal', () => {
            // Use setTimeout to ensure DOM is fully rendered
            setTimeout(() => {
                PriceBook.updateUploadButtonState();
                PriceBook.loadExistingImage();
            }, 100);
        });

        // Handle image upload button click
        $('#invoice-item-modal').off('click', '#item-image-upload-btn').on('click', '#item-image-upload-btn', (ev)=>{
            ev.preventDefault();
            
            // Check if image already exists - check both in files list and in the div next to button
            const hasImageInList = $('#invoice-item-modal #item-image-files-list .attachment-row[data-file-item]').length > 0;
            const hasImageInDiv = $('#invoice-item-modal .d-flex.align-items-center').find('.attachment-row[data-file-item]').length > 0;
            
            if (hasImageInList || hasImageInDiv) {
                alert('Please delete the existing image before uploading a new one.');
                return;
            }
            
            $('#item-image-input').click();
        });
        
        // Handle file input change - upload immediately
        $('#invoice-item-modal').off('change', '#item-image-input').on('change', '#item-image-input', (ev)=>{
            const fileInput = ev.target;
            const file = fileInput.files[0];
            
            if (!file) return;
            
            // Update file name input immediately
            $('#invoice-item-modal #item-image-file-name').val(file.name);
            
            // Validate file type
            if (!file.type.startsWith('image/')) {
                alert('Please select an image file');
                fileInput.value = '';
                $('#invoice-item-modal #item-image-file-name').val('');
                return;
            }
            
            // Validate file size (10MB)
            if (file.size > 10 * 1024 * 1024) {
                alert('Image size must be less than 10MB');
                fileInput.value = '';
                $('#invoice-item-modal #item-image-file-name').val('');
                return;
            }
            
            // Upload immediately
            this.uploadItemImage(file);
        });
        
        // Handle image delete button (for files list)
        $(document).off('click', '.delete-item-image-file').on('click', '.delete-item-image-file', (ev)=>{
            ev.preventDefault();
            ev.stopPropagation();
            const itemId = $(ev.currentTarget).data('item-id');
            // Check if itemId is valid (not undefined, null, 0, or "undefined")
            const isValidItemId = itemId && itemId !== 'undefined' && itemId !== 0 && itemId !== null && !isNaN(itemId) && parseInt(itemId) > 0;
            if (isValidItemId) {
                // Existing item - delete from backend
                this.deleteItemImage(itemId);
            } else {
                // New item - just remove from markup (no backend call)
                // Remove from both locations: files list and div next to button
                $('#invoice-item-modal #item-image-files-list').html('');
                $('#invoice-item-modal .attachment-row[data-file-item]').first().parent().html('<span style=\'opacity: 0.5;\'>Upload an image that best describes this item.</span>');
                $('#invoice-item-modal #item-image-file-name').val('');
                $('#invoice-item-modal').removeData('image-path');
                $('#invoice-item-modal #item-image-path').val('');
                $('#invoice-item-modal #item-image-input').val('');
                this.updateUploadButtonState();
            }
        });
        
        // Bind preview file button handler
        $('body').off('click', '#invoice-item-modal .preview-file-btn').on('click', '#invoice-item-modal .preview-file-btn', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            const imageUrl = $(ev.currentTarget).data('src');
            if (imageUrl) {
                $('#preview-modal #preview-image').attr('src', imageUrl);
                $('#preview-modal').modal('show');
            }
        });
        
    }

    // Old renderPreparedFiles and handleAttachmentsUploaded methods removed - using direct image upload now
    
    static updateUploadButtonState() {
        // Check if image exists (new system - image_path)
        // Check both in files list and in the div next to button
        const hasImageInList = $('#invoice-item-modal #item-image-files-list .attachment-row[data-file-item]').length > 0;
        const hasImageInDiv = $('#invoice-item-modal .d-flex.align-items-center').find('.attachment-row[data-file-item]').length > 0;
        const hasImage = hasImageInList || hasImageInDiv;
        
        const uploadBtn = $('#invoice-item-modal #item-image-upload-btn');
        const fileInput = $('#invoice-item-modal #item-image-input');
        
        if (!uploadBtn.length) {
            return; // Button not found, exit early
        }
        
        const $btnWrap = $('#invoice-item-modal #item-image-upload-btn-wrap');
        if (hasImage) {
            if ($btnWrap.length) $btnWrap.addClass('d-none');
            uploadBtn.prop('disabled', true).addClass('disabled');
            fileInput.prop('disabled', true);
            uploadBtn.text('Upload files');
        } else {
            if ($btnWrap.length) $btnWrap.removeClass('d-none');
            uploadBtn.prop('disabled', false).removeClass('disabled');
            fileInput.prop('disabled', false);
            uploadBtn.text('Upload files');
        }
    }
    
    static uploadItemImage(file) {
        const itemId = $('#invoice-item-modal input[name="id"]').val();
        const formData = new FormData();
        formData.append('image', file);
        
        if (itemId) {
            formData.append('item_id', itemId);
        }
        
        // Show loading state
        const uploadBtn = $('#invoice-item-modal #item-image-upload-btn');
        const originalText = uploadBtn.text();
        uploadBtn.prop('disabled', true).text('Uploading...');
        
        $.ajax({
            url: '/price-book/item/upload-image',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: (response) => {
                    if (response.success) {
                        // Store image_path for saving with form
                        const imagePath = response.image_path;
                        $('#invoice-item-modal').data('image-path', imagePath);
                        // Also update hidden input
                        $('#invoice-item-modal #item-image-path').val(imagePath || '');
                        
                        // Update file name input
                        const fileName = file ? file.name : '';
                        if (fileName) {
                            $('#invoice-item-modal #item-image-file-name').val(fileName);
                        }
                        
                        // Update image display in div next to button (not in files list)
                        const imageUrl = imagePath ? `/files/${imagePath}` : '';
                        // Only set item_id if it's a valid existing item (not for new items)
                        const itemIdForDelete = (response.item_id && response.item_id > 0) ? response.item_id : (itemId && itemId > 0 ? itemId : '');
                        
                        // Target the upload section only: the content div next to #item-image-upload-btn-wrap
                        const $contentDiv = $('#invoice-item-modal #item-image-upload-btn-wrap').next('div');
                        
                        if (imageUrl && $contentDiv.length) {
                            // Only include data-item-id if we have a valid item ID
                            const itemIdAttr = itemIdForDelete ? `data-item-id="${itemIdForDelete}"` : '';
                            const fileItemHtml = `
                                <div class="attachment-row d-flex flex-column justify-content-between align-items-center" data-file-item>
                                    <div class="d-flex align-items-center w-100">
                                        <img width="16" src="/images/file-image.svg" alt="icon-file" class="mr-2">
                                        <div class="cursor-pointer filename item-filename-ellipsis" style="text-decoration: underline" title="${(fileName || '').replace(/"/g, '&quot;')}">${fileName || ''}</div>
                                    </div>
                                    <div class="d-flex" style="gap: 1rem;">
                                        <span class="text-underline cursor-pointer preview-file-btn" style="font-size: 10px; color: gray;" data-src="${imageUrl}">preview</span>
                                        <span class="text-underline cursor-pointer delete-item-image-file" style="font-size: 10px; color: gray;" ${itemIdAttr}>delete</span>
                                    </div>
                                </div>
                            `;
                            $contentDiv.html(fileItemHtml);
                            
                            // Bind delete handler
                            $('#invoice-item-modal').off('click', '.delete-item-image-file').on('click', '.delete-item-image-file', function() {
                                const deleteItemId = $(this).data('item-id');
                                // Check if deleteItemId is valid (not undefined, null, 0, or "undefined")
                                const isValidItemId = deleteItemId && deleteItemId !== 'undefined' && deleteItemId !== 0 && deleteItemId !== null && !isNaN(deleteItemId) && parseInt(deleteItemId) > 0;
                                if (isValidItemId) {
                                    // Existing item - delete from backend
                                    PriceBook.deleteItemImage(deleteItemId);
                                } else {
                                    // New item - just remove from markup (no backend call)
                                    $('#invoice-item-modal .attachment-row[data-file-item]').first().parent().html('<span style=\'opacity: 0.5;\'>Upload an image that best describes this item.</span>');
                                    $('#invoice-item-modal #item-image-file-name').val('');
                                    $('#invoice-item-modal').removeData('image-path');
                                    $('#invoice-item-modal #item-image-path').val('');
                                    $('#invoice-item-modal #item-image-input').val('');
                                    PriceBook.updateUploadButtonState();
                                }
                            });
                            
                            // Update image in table if item is being edited in quote form
                            if (itemId) {
                                PriceBook.updateImageInTable(itemId, imageUrl);
                            }
                        }
                        
                        // Update button state
                        PriceBook.updateUploadButtonState();
                        
                        // Clear file input
                        $('#invoice-item-modal #item-image-input').val('');
                    } else {
                        alert(response.error || 'Error uploading image');
                        uploadBtn.prop('disabled', false).text(originalText);
                    }
            },
            error: (xhr) => {
                console.error('Error uploading image:', xhr);
                alert('Error uploading image. Please try again.');
                uploadBtn.prop('disabled', false).text(originalText);
            }
        });
    }
    
    static deleteItemImage(itemId) {
        // Check if itemId is valid (not undefined, null, 0, or "undefined")
        const isValidItemId = itemId && itemId !== 'undefined' && itemId !== 0 && itemId !== null && !isNaN(itemId) && parseInt(itemId) > 0;
        if (!isValidItemId) {
            // If no valid item_id (new item), just clear files list (no backend call)
            // Remove from both locations: files list and div next to button
            $('#invoice-item-modal #item-image-files-list').html('');
            $('#invoice-item-modal .d-flex.align-items-center').find('.attachment-row[data-file-item]').closest('div').html('<span style=\'opacity: 0.5;\'>Upload an image that best describes this item.</span>');
            $('#invoice-item-modal #item-image-file-name').val('');
            $('#invoice-item-modal').removeData('image-path');
            $('#invoice-item-modal #item-image-path').val('');
            $('#invoice-item-modal #item-image-input').val('');
            PriceBook.updateUploadButtonState();
            return;
        }
        
        // Convert to int for safety
        const itemIdInt = parseInt(itemId);
        
        $.ajax({
            url: `/price-book/item/${itemIdInt}/delete-image`,
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: (response) => {
                if (response.success) {
                    // Clear files list
                    $('#invoice-item-modal #item-image-files-list').html('');
                    // Remove from div next to button and restore text
                    $('#invoice-item-modal .attachment-row[data-file-item]').first().parent().html('<span style=\'opacity: 0.5;\'>Upload an image that best describes this item.</span>');
                    $('#invoice-item-modal #item-image-file-name').val('');
                    
                    // Clear stored image_path
                    $('#invoice-item-modal').removeData('image-path');
                    $('#invoice-item-modal #item-image-path').val('');
                    
                    // Update button state
                    PriceBook.updateUploadButtonState();
                    
                    // Clear file input
                    $('#invoice-item-modal #item-image-input').val('');
                    
                    // Update image in table if item is being edited in quote form
                    if (itemId) {
                        PriceBook.updateImageInTable(itemId, '');
                    }
                }
            },
            error: (xhr) => {
                console.error('Error deleting image:', xhr);
            }
        });
    }
    
    static loadExistingImage() {
        // Files list is already rendered by Blade template if image_path exists
        // Check both locations: files list and div next to button
        const filesList = $('#invoice-item-modal #item-image-files-list .attachment-row');
        const imageInDiv = $('#invoice-item-modal .d-flex.align-items-center').find('.attachment-row[data-file-item]');
        
        if (filesList.length > 0) {
            const fileName = filesList.find('.filename').text();
            if (fileName) {
                $('#invoice-item-modal #item-image-file-name').val(fileName);
            }
        } else if (imageInDiv.length > 0) {
            const fileName = imageInDiv.find('.filename').text();
            if (fileName) {
                $('#invoice-item-modal #item-image-file-name').val(fileName);
            }
        }

        // Bind delete handler for existing files
        $(document).off('click', '.delete-item-image-file').on('click', '.delete-item-image-file', function() {
            const itemId = $(this).data('item-id');
            // Check if itemId is valid (not undefined, null, 0, or "undefined")
            const isValidItemId = itemId && itemId !== 'undefined' && itemId !== 0 && itemId !== null && !isNaN(itemId) && parseInt(itemId) > 0;
            if (isValidItemId) {
                // Existing item - delete from backend
                PriceBook.deleteItemImage(itemId);
            } else {
                // New item - just remove from markup (no backend call)
                // Remove from both locations: files list and div next to button
                $('#invoice-item-modal #item-image-files-list').html('');
                $('#invoice-item-modal .attachment-row[data-file-item]').first().parent().html('<span style=\'opacity: 0.5;\'>Upload an image that best describes this item.</span>');
                $('#invoice-item-modal #item-image-file-name').val('');
                $('#invoice-item-modal').removeData('image-path');
                $('#invoice-item-modal #item-image-path').val('');
                $('#invoice-item-modal #item-image-input').val('');
                PriceBook.updateUploadButtonState();
            }
        });

        // Update button state
        PriceBook.updateUploadButtonState();
    }
    
    static updateImageInTable(itemId, imageUrl) {
        // Find item row in quote/invoice form tables
        const possibleForms = [
            '#create-quote-container form',
            '#edit-quote-container form',
            '#create-invoice-container form',
            '#edit-invoice-container form'
        ];
        
        for(let formSelector of possibleForms) {
            const $form = $(formSelector);
            if($form.length > 0) {
                const itemRow = $form.find('.item').filter(function() {
                    const $item = $(this);
                    const rowItemId = $item.find('input[name="item_id"]').val();
                    return rowItemId && rowItemId.toString() === itemId.toString();
                });
                
                if(itemRow.length > 0) {
                    const $imageContainer = itemRow.find('.form-group.image');
                    if($imageContainer.length) {
                        if (imageUrl) {
                            $imageContainer.html(`<img src="${imageUrl}" alt="Preview" class="preview-file-btn" data-src="${imageUrl}" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer; border-radius: 4px;">`);
                        } else {
                            $imageContainer.html('');
                        }
                    }
                    break;
                }
            }
        }
    }

    static maskNumber(ev){
        let value = $(ev.currentTarget).val()
        if (/[^0-9\.]*/.test(value))
            value = value.replace(/[^0-9\.]*/g, '')
        if (value.toString().match(/[.]/g)?.length > 1 || /\.\d{3,}/.test(value))
            value = value.substring(0, value.length - 1)
        $(ev.target).val(value)
    }

    static maskInteger(ev){
        let value = $(ev.currentTarget).val()
        if (/[^0-9]*/.test(value))
            value = value.replace(/[^0-9]*/g, '')
        $(ev.target).val(value)
    }
}